import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export class EstateDashboardRouteConfig extends CurrentEstateRouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const authUser = getters.auth.getUser();
    if (authUser.currentEstate?.isSelfServePlan && !authUser.isNotary) {
      return authUser.permission.canAccessClearWillDashboardPage;
    }

    return !authUser.isManagingEstates;
  }
}
